import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import getCity from '../../api/getCity';
import { getInsurance } from '../../api/getInsurance';
import { useNavigate } from 'react-router-dom';
import { buildSearch } from '../../common/utils/url';
import fetchAuthenticatedUser from '../../api/fetchAuthenticatedUser';
import { format } from 'date-fns';
 
const useSearch = () => {
  const [formError, setFormError] = useState(false);
  const [error, setError] = useState('');
  const [cities, setCities] = useState([]);
  const [insurance, setInsurance] = useState([]);
  const navigate = useNavigate();
  const { control, handleSubmit, register, reset, getValues, setValue } = useForm();
 
  const onSearch = async ({ doctorName,insurance, specialty, date: dateData, city }) => {
  
    let date;
    setError('');
    
      setFormError(false);
      if (dateData) {
        date = format(dateData, "yyyy-MM-dd");
      }
      // const user = await fetchAuthenticatedUser();
      // if (user.id)
        navigate({
          pathname: '/search-results',
          search: buildSearch({    
            doctorName:doctorName,
            insurance: insurance,
            q: specialty,
            date,
            city: city?.id})
        });
      // else setError('Tienes que iniciar sesión para realizar la búsqueda');
    //  else {
    //   setFormError(true);
    //   navigate({
    //     pathname: '/'
    //   })
    // }
  };
 
  useEffect(() => {
    const getData = async () => {
      const data = await getCity(setError);
      if(data?.length > 0){
        setCities(data?.map((city) => ({ ...city, label: city?.name, value: city?.name })));
      }else{
        setCities([])
      }
    };
 
    getData();
  }, []);
 
  return { control, handleSubmit, onSearch, formError, register, cities, error, reset, getValues, setValue };
};
 
export default useSearch;